// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import Montserrat font */

/* Reset styles */
* {
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Montserrat', Arial, Verdana;
}

/* Form styles */
#msform {
  width: 400px;
  margin: 50px auto;
  text-align: center;
  position: relative;
}

#msform fieldset {
  background-image: linear-gradient(135deg, #004658 0%, #027b9a 100%);
  height: 50vh;
  width: 50vw;
  border: none;
  border-radius: 3px;
  padding: 20px 30px;
  width: 80%;
  margin: 0 10%;
  position: relative;
}

/* Hide all except current fieldset */
#msform fieldset {
  display: none;
}

#msform fieldset.active {
  display: block;
}

/* Input styles */
#msform input,
#msform textarea {
  padding: 15px;
  border-radius: 3px;
  margin-bottom: 10px;
  width: 100%;
  box-sizing: border-box;
  font-size: 13px;
}

/* Button styles */
#msform .action-button {
  width: 100px;
  background: #27ae60;
  font-weight: bold;
  color: white;
  border: none;
  border-radius: 1px;
  cursor: pointer;
  padding: 10px;
  margin: 10px 5px;
  text-decoration: none;
  font-size: 14px;
}

#msform .action-button:hover,
#msform .action-button:focus {
  box-shadow: 0 0 0 2px white, 0 0 0 3px #27ae60;
}

/* Progress bar */
#progressbar {
  margin-bottom: 30px;
  margin-left: 25px;
  overflow: hidden;
  counter-reset: step;
}

#progressbar li {
  list-style-type: none;
  color: white;
  text-transform: uppercase;
  font-size: 9px;
  width: 33.33%;
  float: left;
  position: relative;
}

#progressbar li:before {
  content: counter(step);
  counter-increment: step;
  width: 20px;
  line-height: 20px;
  display: block;
  font-size: 10px;
  color: #333;
  background: white;
  border-radius: 3px;
  margin: 0 auto 5px auto;
}

/* Progress bar connectors */
#progressbar li:after {
  content: '';
  width: 100%;
  height: 2px;
  background: white;
  position: absolute;
  left: -50%;
  top: 9px;
  z-index: -1;
}

#progressbar li:first-child:after {
  content: none;
}

/* Mark active steps */
#progressbar li.active:before,
#progressbar li.active:after {
  background: #27ae60;
  color: white;
}

.progress {
    height: 20px;
    background-color: #f3f3f3;
    border-radius: 10px;
    margin-bottom: 20px;
    overflow: hidden;
  }
  
  .progress-bar {
    height: 100%;
    background-color: #27AE60;
    transition: width 0.4s ease;
    color: white;
    text-align: center;
    line-height: 20px;
    font-size: 12px;
  }
  
  .confirmation-card {
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding: 20px;
    margin-top: 20px;
    text-align: left;
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
  }
  
  .confirmation-list {
    list-style: none;
    padding: 0;
  }
  
  .confirmation-list li {
    margin-bottom: 10px;
    padding: 10px;
    border-bottom: 1px solid #e0e0e0;
  }
  
  .confirmation-list li strong {
    color: #2C3E50;
    font-weight: 600;
    width: 140px;
    display: inline-block;
  }
  
  .confirmation-list li:last-child {
    border-bottom: none;
  }
  
  .fs-title {
    text-align: center;
    font-size: 22px;
    color: #2C3E50;
    margin-bottom: 20px;
  }
  
  .fs-title + .confirmation-card {
    margin-top: 10px;
  }
  
  .confirmation-card ul li {
    font-size: 16px;
    line-height: 1.6;
    color: #555;
  }
  
  .confirmation-card ul li strong {
    font-size: 17px;
    color: #333;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Shop/CreateShop.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAG3B,iBAAiB;AACjB;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mEAAmE;EACnE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;;EAEE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,gCAAgC;EAClC;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb","sourcesContent":["/* Import Montserrat font */\n@import url('https://fonts.googleapis.com/css?family=Montserrat');\n\n/* Reset styles */\n* {\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: 'Montserrat', Arial, Verdana;\n}\n\n/* Form styles */\n#msform {\n  width: 400px;\n  margin: 50px auto;\n  text-align: center;\n  position: relative;\n}\n\n#msform fieldset {\n  background-image: linear-gradient(135deg, #004658 0%, #027b9a 100%);\n  height: 50vh;\n  width: 50vw;\n  border: none;\n  border-radius: 3px;\n  padding: 20px 30px;\n  width: 80%;\n  margin: 0 10%;\n  position: relative;\n}\n\n/* Hide all except current fieldset */\n#msform fieldset {\n  display: none;\n}\n\n#msform fieldset.active {\n  display: block;\n}\n\n/* Input styles */\n#msform input,\n#msform textarea {\n  padding: 15px;\n  border-radius: 3px;\n  margin-bottom: 10px;\n  width: 100%;\n  box-sizing: border-box;\n  font-size: 13px;\n}\n\n/* Button styles */\n#msform .action-button {\n  width: 100px;\n  background: #27ae60;\n  font-weight: bold;\n  color: white;\n  border: none;\n  border-radius: 1px;\n  cursor: pointer;\n  padding: 10px;\n  margin: 10px 5px;\n  text-decoration: none;\n  font-size: 14px;\n}\n\n#msform .action-button:hover,\n#msform .action-button:focus {\n  box-shadow: 0 0 0 2px white, 0 0 0 3px #27ae60;\n}\n\n/* Progress bar */\n#progressbar {\n  margin-bottom: 30px;\n  margin-left: 25px;\n  overflow: hidden;\n  counter-reset: step;\n}\n\n#progressbar li {\n  list-style-type: none;\n  color: white;\n  text-transform: uppercase;\n  font-size: 9px;\n  width: 33.33%;\n  float: left;\n  position: relative;\n}\n\n#progressbar li:before {\n  content: counter(step);\n  counter-increment: step;\n  width: 20px;\n  line-height: 20px;\n  display: block;\n  font-size: 10px;\n  color: #333;\n  background: white;\n  border-radius: 3px;\n  margin: 0 auto 5px auto;\n}\n\n/* Progress bar connectors */\n#progressbar li:after {\n  content: '';\n  width: 100%;\n  height: 2px;\n  background: white;\n  position: absolute;\n  left: -50%;\n  top: 9px;\n  z-index: -1;\n}\n\n#progressbar li:first-child:after {\n  content: none;\n}\n\n/* Mark active steps */\n#progressbar li.active:before,\n#progressbar li.active:after {\n  background: #27ae60;\n  color: white;\n}\n\n.progress {\n    height: 20px;\n    background-color: #f3f3f3;\n    border-radius: 10px;\n    margin-bottom: 20px;\n    overflow: hidden;\n  }\n  \n  .progress-bar {\n    height: 100%;\n    background-color: #27AE60;\n    transition: width 0.4s ease;\n    color: white;\n    text-align: center;\n    line-height: 20px;\n    font-size: 12px;\n  }\n  \n  .confirmation-card {\n    background-color: #ffffff;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    padding: 20px;\n    margin-top: 20px;\n    text-align: left;\n    max-width: 500px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  \n  .confirmation-list {\n    list-style: none;\n    padding: 0;\n  }\n  \n  .confirmation-list li {\n    margin-bottom: 10px;\n    padding: 10px;\n    border-bottom: 1px solid #e0e0e0;\n  }\n  \n  .confirmation-list li strong {\n    color: #2C3E50;\n    font-weight: 600;\n    width: 140px;\n    display: inline-block;\n  }\n  \n  .confirmation-list li:last-child {\n    border-bottom: none;\n  }\n  \n  .fs-title {\n    text-align: center;\n    font-size: 22px;\n    color: #2C3E50;\n    margin-bottom: 20px;\n  }\n  \n  .fs-title + .confirmation-card {\n    margin-top: 10px;\n  }\n  \n  .confirmation-card ul li {\n    font-size: 16px;\n    line-height: 1.6;\n    color: #555;\n  }\n  \n  .confirmation-card ul li strong {\n    font-size: 17px;\n    color: #333;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
